import React, { ReactNode, useState } from 'react'
import { Outlet } from 'react-router-dom'
import Header from '../../components/dashboard/Header'
import ProfileTabs from '../../components/user/ProfileTabs'
import Page from '../../components/layout/Helmet'
import { t } from 'i18next'

function User() {
    const [title, setTitle] = useState('')
    const [element, setElement] = useState<ReactNode | null>(null)

    return (
        <Page withNameApp title={'settings:title'}>
            <Header text={title} >
                {element}
            </Header>
            <ProfileTabs onRouteChanged={(text, el) => {
                setTitle(text ?? "")
                setElement(el)
            }}>
                <Outlet></Outlet>
            </ProfileTabs>
        </Page>
    )
}

export default User